import clsx from 'clsx';
import React from 'react';
import { Outlet } from 'react-router-dom';
import useSidebarHook from '../../hooks/custom-hooks/useSidebarHook';

import Header2 from '../header/Header2';
import Sidebar from '../sidebar/Sidebar';

function AppLayout(props) {
  const { isSidebarOpen, setIsSidebarOpen, sidebarRef } = useSidebarHook();

  return (
    <div>
      <Header2 {...props} setOpenSidebar={setIsSidebarOpen} isSidebarOpen={isSidebarOpen} />
      <main className='mx-auto my-0 max-w-screen-cwidth'>
        <section className='flex h-[calc(100vh-60px)] flex-row break:h-[calc(100vh-75px)]'>
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
            sidebarRef={sidebarRef}
          />
          <div className={clsx('w-full overflow-hidden bg-nwhite-200', 'break:pl-5 break:pt-5')}>
            <div
              className={clsx(
                'break:h-full break:overflow-auto break:bg-white break:px-7 break:pt-[30px] breakMax:p-2',
              )}
            >
              <Outlet />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

AppLayout.propTypes = {};

export default AppLayout;
